export function readStoredValue<T>(
  key: string | undefined,
  fallback: T,
  validate?: (value: unknown) => boolean,
): T {
  if (!key) return fallback;

  try {
    const stored = window.localStorage.getItem(key);
    if (stored === null) return fallback;
    const value: unknown = JSON.parse(stored);
    return validate && !validate(value) ? fallback : (value as T);
  } catch {
    return fallback;
  }
}

export function writeStoredValue(key: string | undefined, value: unknown) {
  if (!key) return false;

  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
